import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import homePage from '../views/home_page.vue'
import loginPage from '../views/login_page.vue'
import login from '../views/login'
import introChuancheng from '../views/home_page/intro_chuancheng.vue'
import introPlatform from '../views/home_page/intro_platform.vue'
import introTizhi from '../views/home_page/intro_tizhi.vue'
import introAssistant from '../views/home_page/intro_assistant.vue'
// import medicalLibrary from '../views/medicalLibrary'
import { Message } from 'element-ui';
import axios from 'axios';
// import { getCookie } from "@/utils/auth.js"
Vue.prototype.$http = axios
Vue.prototype.$message = Message;
Vue.use(VueRouter)

const routes = [
	{
		path:'/',
		redirect:'/homePage', 
	},
  	{
		path: '/homePage',
		name: 'homePage',
		component: homePage,
		meta: { title: '首页', requiredLogin: false }
	},
	{
		path: '/loginPage',
		name: 'loginPage',
		component: loginPage,
		meta: { title: '登录页', requiredLogin: false }
	},
	{
		path: '/introChuancheng',
		name: 'introChuancheng',
		component: introChuancheng,
		meta: { title: '传承介绍', requiredLogin: false }
	},
	{
		path: '/introPlatform',
		name: 'introPlatform',
		component: introPlatform,
		meta: { title: '平台介绍', requiredLogin: false }
		
	},
	{
		path: '/introTizhi',
		name: 'introTizhi',
		component: introTizhi,
		meta: { title: '中医养生仪介绍', requiredLogin: false }
		
	},
	{
		path: '/introAssistant',
		name: 'introAssistant',
		component: introAssistant,
		meta: { title: '中医助理智能机器人介绍', requiredLogin: false }
		
	},
	{
		path: '/login',
		name: 'login',
		component: login,
		meta: { title: '其他页面', requiredLogin: false }
	},
	// {
	// 	path: '/medicalLibrary',
	// 	name: 'MedicalLibrary',
	// 	component: medicalLibrary,
	// 	meta: { title: '我的医案库页面', requiredLogin: false }
	// },
]




const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})



router.beforeEach( (to, from, next) => {
 
  if (to.matched.some(record => record.meta.requiredLogin)) {
    // 判断用户是否处于登录状态
    // console.log('store.getters.isLogin=',store.getters.isLogin)
    if (!getCookie.getItem('token')) {
      // next('/sign-in')
      Message({
        message: '此模块需要登录，请先登录再操作！',
        type: 'warning'
      });
      // console.log('to.fullPath=',to.fullPath)
      // router.push({ path: '/sign-in', query: {redirect:to.fullPath}});
      router.push({ path: '/login'});
    } else {
      if (to.meta.title) {
        document.title = to.meta.title
      }
      next();
      if (getCookie.getItem('token')) {
        store.commit("userToken", sessionStorage.getItem('token'))
      }
      if (to.path === '/login') return next();
      const token = sessionStorage.getItem('token')
      // if (!token) return next('/index');
      // next();
    }
  } else {
    next()
  }
})
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router
